import Container from './StorageCapacityWithUpsell.container';
import StorageCapacityWithUpsell from './StorageCapacityWithUpsell';

export default Container(StorageCapacityWithUpsell);
